
import { Search as SearchIcon } from "lucide-react";
import { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";

interface SearchBarProps {
  onSearch?: (query: string) => void;
  placeholder?: string;
}

const SearchBar = ({ onSearch, placeholder = "Search for any brands or competitors..." }: SearchBarProps) => {
  const [query, setQuery] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    window.open(
      'https://calendar.google.com/calendar/appointments/schedules/AcZssZ0ixREziCGTZSnjXhuPB0TBIti2X5Ks-ATre2wgAkuMuHqJ4XWW7hldUQxV7WW_GMwHwd9IwfBm?gv=true',
      'BookADemo',
      'width=1400,height=900'
    );
    
    if (onSearch) {
      onSearch(query);
    }
  };

  return (
    <div className="flex flex-col items-center space-y-4 w-full max-w-2xl mx-auto">
      <form onSubmit={handleSubmit} className="relative flex w-full">
        <div className="relative flex-1">
          <Input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder={placeholder}
            className="w-full h-12 pl-12 pr-4 text-base bg-white dark:bg-benchr-900/40 border-2 border-benchr-100 dark:border-benchr-700 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-benchr-500 dark:focus:ring-benchr-400 focus:border-transparent transition-all duration-200"
          />
          <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-benchr-400" />
        </div>
        <Button 
          type="submit"
          variant="primary"
          className="h-12 px-6 rounded-l-none rounded-r-lg"
        >
          Search
        </Button>
      </form>
      
      <div className="flex items-center justify-center gap-4 pt-2">
        <a 
          href="https://www.walmart.com" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="flex items-center gap-2 px-4 py-2 bg-white dark:bg-benchr-900/40 rounded-full border border-benchr-100 dark:border-benchr-700 hover:bg-benchr-50 dark:hover:bg-benchr-800/40 transition-colors"
        >
          <img
            src="https://www.google.com/s2/favicons?domain=walmart.com&sz=32"
            alt="Walmart"
            className="w-6 h-6"
          />
          <span className="text-sm text-benchr-600 dark:text-benchr-300">walmart.com</span>
        </a>
        <a 
          href="https://www.sephora.com" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="flex items-center gap-2 px-4 py-2 bg-white dark:bg-benchr-900/40 rounded-full border border-benchr-100 dark:border-benchr-700 hover:bg-benchr-50 dark:hover:bg-benchr-800/40 transition-colors"
        >
          <img
            src="https://www.google.com/s2/favicons?domain=sephora.com&sz=32"
            alt="Sephora"
            className="w-6 h-6"
          />
          <span className="text-sm text-benchr-600 dark:text-benchr-300">sephora.com</span>
        </a>
        <a 
          href="https://www.uniqlo.com" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="flex items-center gap-2 px-4 py-2 bg-white dark:bg-benchr-900/40 rounded-full border border-benchr-100 dark:border-benchr-700 hover:bg-benchr-50 dark:hover:bg-benchr-800/40 transition-colors"
        >
          <img
            src="https://www.google.com/s2/favicons?domain=uniqlo.com&sz=32"
            alt="Uniqlo"
            className="w-6 h-6"
          />
          <span className="text-sm text-benchr-600 dark:text-benchr-300">uniqlo.com</span>
        </a>
      </div>
    </div>
  );
};

export default SearchBar;
